import { render, staticRenderFns } from "./AppInfoModal.vue?vue&type=template&id=774db33a&scoped=true&"
import script from "./AppInfoModal.vue?vue&type=script&lang=js&"
export * from "./AppInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoModal.vue?vue&type=style&index=0&id=774db33a&scoped=true&lang=scss&"
import style1 from "./AppInfoModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774db33a",
  null
  
)

export default component.exports